import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import IndexCard from "../../../shared/IndexCard/IndexCard";
import { Link, useOutletContext } from "react-router-dom";

const ProjectListPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const openProjects = projects;

  // 希望条件の有無（contractExists）と
  // 公開・非公開ステータス（isActive）を ProjectLayout から受け取る
  const { contractExists, isActive } = useOutletContext();

  const fetchProjects = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch("/projects.json", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!res.ok) {
        const text = await res.text();
        console.error("projects.json error", res.status, text);
        if (res.status === 403) {
          setProjects([]);
        } else {
          setProjects([]);
        }
        return;
      }
      const data = await res.json();
      setProjects(data);
    } catch (err) {
      console.error("fetchProjects failed:", err);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
    const onFocus = () => fetchProjects();
    const onVisibility = () =>
      document.visibilityState === "visible" && fetchProjects();
    const onPageShow = (e) => e.persisted && fetchProjects();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pageshow", onPageShow);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [fetchProjects]);

  const handleMarkedRead = useCallback((projectId) => {
    setProjects((prev) =>
      prev.map((p) => (p.id === projectId ? { ...p, read_flag: true } : p))
    );
  }, []);

  return (
    <>
      <Box sx={{ maxWidth: 960, mx: "auto", mb: 10 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" mt={5}>
            <CircularProgress />
          </Box>
        ) : openProjects.length === 0 ? (
          <Typography color="text.secondary" sx={{ mt: 4 }}>
            現在、公開中のプロジェクトはありません。
            <br />
            お問い合わせ内容をもとに、条件に合うプロジェクトをご案内できる場合があります。
            <br />
            お問い合わせフォームよりお気軽にご連絡ください。
          </Typography>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            {openProjects.map((project) => (
              <IndexCard
                key={project.id}
                item={project}
                type="project"
                component={Link}
                to={`/projects/${project.id}`} // ユーザー向け詳細ページへ
                onMarkedRead={handleMarkedRead}
                contractExists={contractExists}
                isActive={isActive}
              />
            ))}
          </Box>
        )}
      </Box>
    </>
  );
};

export default ProjectListPage;
